import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

import { RequestNextApi } from '../../../../api/Request';
import { ProgressContext } from '../../../../components/Context/progressContext';
import MarketingNavigation from '../../../../navigation/marketing';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../../utils/static-pages/model';

export default function FindStudyGroup() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    const router = useRouter();

    useEffect(() => {
        const handleRouteChange = (url, { shallow }) => {
            if (!url.includes('find-a-study-group')) {
                localStorage.setItem('pageData', null);
            }
        };

        router.events.on('routeChangeStart', handleRouteChange);

        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_FIND_A_STUDY_GROUP,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');    
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({isLoading: true});
            await fetchPage();
            updateProgress({isLoading: false});
        };

        initPage();

        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
        };
    }, []);

    return (
        <>
            <Head>
                <title>Find a Study Group Near You | Kingdom Advisors</title>
                <meta name="description" content="Discover Kingdom Advisors Study Groups near you. Connect with like-minded professionals for meaningful discussions around biblical wisdom." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--community-study-groups'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

FindStudyGroup.getLayout = page => <>{page}</>;
FindStudyGroup.isPublic = true;
